import { derived } from 'svelte/store';
import { NewListItemsStore } from '../common/new-list-items-store';
export default function registerNewMessageNotificationSounds(messages, myActiveConversation, soundPlayer) {
    const myActiveConversationMessages = derived([messages, myActiveConversation], ([_messages, _myActiveConversation]) => {
        if (!_myActiveConversation) {
            return [];
        }
        return _messages.filter(message => message.conversationId === _myActiveConversation.id);
    });
    const newMessages = new NewListItemsStore(myActiveConversationMessages);
    newMessages.subscribe(_newMessages => {
        if (_newMessages.length > 0) {
            soundPlayer.playNewMessageNotification();
        }
    });
}
